import React, { type ReactNode } from "react";

import clsx from "clsx";

interface Props {
  children: ReactNode;
  active?: boolean;
  onClick(): void;
}

export const Tab = ({ children, active, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        "w-64 h-10 px-2.5 flex items-center cursor-pointer z-[2]",
        "border rounded-t-lg text-interstellar+2",
        {
          "bg-[#f8f8f9] border-gray-0 ": !active,
          "hover:border-t-primary hover:border-x-primary hover:bg-cosmic-4":
            !active,
          "bg-white border-t-gray-0 border-x-gray-0 border-b-white": active,
        },
      )}
    >
      <div
        className={clsx("flex-1", {
          "text-primary font-semibold": active,
        })}
      >
        {children}
      </div>
    </div>
  );
};
